// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-social-signins-___styles__buttonContainer___tHbUr{display:flex;flex-direction:column}.src-components-social-signins-___styles__buttonContainer___tHbUr .src-components-social-signins-___styles__btn___ibWcJ{border:0;border-radius:4px;display:inline-block;font-size:17px;font-weight:700;height:44px;line-height:20px;margin:5px 0;opacity:.85;padding:12px;text-decoration:none;width:100%}.src-components-social-signins-___styles__buttonContainer___tHbUr .src-components-social-signins-___styles__fbBtn___D\\+1oE{background-color:#3b5998;color:#fff}.src-components-social-signins-___styles__buttonContainer___tHbUr .src-components-social-signins-___styles__googleBtn___ucjRS{background-color:#dd4b39;color:#fff}.src-components-social-signins-___styles__buttonContainer___tHbUr .src-components-social-signins-___styles__appleBtn___HkeLP{background-color:#333;color:#fff}", "",{"version":3,"sources":["webpack://src/components/social-signins/styles.scss"],"names":[],"mappings":"AAAsuC,kEAAiB,YAAY,CAAC,qBAAqB,CAAC,wHAAsB,QAAQ,CAAC,iBAAiB,CAAC,oBAAoB,CAAC,cAAc,CAAC,eAAe,CAAC,WAAW,CAAC,gBAAgB,CAAC,YAAY,CAAC,WAAW,CAAC,YAAY,CAAC,oBAAoB,CAAC,UAAU,CAAC,2HAAwB,wBAAwB,CAAC,UAAU,CAAC,8HAA4B,wBAAwB,CAAC,UAAU,CAAC,6HAA2B,qBAAqB,CAAC,UAAU","sourcesContent":[":export{bannerRed:rgba(218,20,20,.1);bannerSuccess:rgba(90,202,117,.3);blue:#1c5898;boxShadowGrey:rgba(11,9,44,.2);btnActive:#0095e2;btnDefault:#2fb4f9;btnDisabled:#acb8bc;btnGhostActive:rgba(0,149,226,.1);btnGhostDefault:rgba(0,0,0,0);btnGhostHover:rgba(100,193,241,.1);btnHover:#64c1f1;btnSecondaryActive:rgba(0,149,226,.1);btnSecondaryDefault:rgba(47,180,249,.1);btnSecondaryDisabled:#f4f6f6;btnSecondaryHover:rgba(100,193,241,.1);charcoal:#333;coral:#ed7f69;darkGrey:#6b6c7e;error:#da1414;errorColor:#da1414;faintBlue:rgba(28,88,152,.05);green:#59bf28;grey:#acb8bc;lightBlue:#2fb4f9;lightGrayRuler:#f4f6f6;lightGrey:#f1f1f1;lightPineTree:#e5f3f0;modalOverlay:rgba(32,33,38,.45);modalWrapperBackground:rgba(0,0,0,.2);olive:#20cb9a;orange:#fe7a24;peach:#fdc;pineTree:#4e8c8a;primary:#26b1e2;primaryHover:#64c1f1;red:#fa1931;sea:rgba(47,181,249,.1);seaPrimary:#2fb4f9;seaPrimaryWithAlpha:rgba(47,180,249,.1);secondary:#ffa959;silver:#acb8bc;success:#70c063;warning:#ff8f39;white:#fff}:export{hugeFont:36px;inputHeight:38px;l:24px;lFont:18px;m:20px;s:16px;sFont:14px;slimButtonHeight:24px;smallestFont:10px;smallestSpacer:5px;spacer:15px;standardFont:14px;xl:28px;xs:12px;xsFont:12px;xxl:32px;xxs:8px;xxsFont:10px;xxxl:40px;xxxs:4px;xxxxl:64px;xxxxs:2px}.buttonContainer{display:flex;flex-direction:column}.buttonContainer .btn{border:0;border-radius:4px;display:inline-block;font-size:17px;font-weight:700;height:44px;line-height:20px;margin:5px 0;opacity:.85;padding:12px;text-decoration:none;width:100%}.buttonContainer .fbBtn{background-color:#3b5998;color:#fff}.buttonContainer .googleBtn{background-color:#dd4b39;color:#fff}.buttonContainer .appleBtn{background-color:#333;color:#fff}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerRed": "rgba(218,20,20,.1)",
	"bannerSuccess": "rgba(90,202,117,.3)",
	"blue": "#1c5898",
	"boxShadowGrey": "rgba(11,9,44,.2)",
	"btnActive": "#0095e2",
	"btnDefault": "#2fb4f9",
	"btnDisabled": "#acb8bc",
	"btnGhostActive": "rgba(0,149,226,.1)",
	"btnGhostDefault": "rgba(0,0,0,0)",
	"btnGhostHover": "rgba(100,193,241,.1)",
	"btnHover": "#64c1f1",
	"btnSecondaryActive": "rgba(0,149,226,.1)",
	"btnSecondaryDefault": "rgba(47,180,249,.1)",
	"btnSecondaryDisabled": "#f4f6f6",
	"btnSecondaryHover": "rgba(100,193,241,.1)",
	"charcoal": "#333",
	"coral": "#ed7f69",
	"darkGrey": "#6b6c7e",
	"error": "#da1414",
	"errorColor": "#da1414",
	"faintBlue": "rgba(28,88,152,.05)",
	"green": "#59bf28",
	"grey": "#acb8bc",
	"lightBlue": "#2fb4f9",
	"lightGrayRuler": "#f4f6f6",
	"lightGrey": "#f1f1f1",
	"lightPineTree": "#e5f3f0",
	"modalOverlay": "rgba(32,33,38,.45)",
	"modalWrapperBackground": "rgba(0,0,0,.2)",
	"olive": "#20cb9a",
	"orange": "#fe7a24",
	"peach": "#fdc",
	"pineTree": "#4e8c8a",
	"primary": "#26b1e2",
	"primaryHover": "#64c1f1",
	"red": "#fa1931",
	"sea": "rgba(47,181,249,.1)",
	"seaPrimary": "#2fb4f9",
	"seaPrimaryWithAlpha": "rgba(47,180,249,.1)",
	"secondary": "#ffa959",
	"silver": "#acb8bc",
	"success": "#70c063",
	"warning": "#ff8f39",
	"white": "#fff",
	"hugeFont": "36px",
	"inputHeight": "38px",
	"l": "24px",
	"lFont": "18px",
	"m": "20px",
	"s": "16px",
	"sFont": "14px",
	"slimButtonHeight": "24px",
	"smallestFont": "10px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"standardFont": "14px",
	"xl": "28px",
	"xs": "12px",
	"xsFont": "12px",
	"xxl": "32px",
	"xxs": "8px",
	"xxsFont": "10px",
	"xxxl": "40px",
	"xxxs": "4px",
	"xxxxl": "64px",
	"xxxxs": "2px",
	"buttonContainer": "src-components-social-signins-___styles__buttonContainer___tHbUr",
	"btn": "src-components-social-signins-___styles__btn___ibWcJ",
	"fbBtn": "src-components-social-signins-___styles__fbBtn___D+1oE",
	"googleBtn": "src-components-social-signins-___styles__googleBtn___ucjRS",
	"appleBtn": "src-components-social-signins-___styles__appleBtn___HkeLP"
};
export default ___CSS_LOADER_EXPORT___;
